import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Game, Auth } from '../../../Core'

import UIButton from '../../UI/UIButton'
import * as docActions from '../documents.actions'

/**
 *  Pop up showed when you have finished the game
 */
class DocumentsButton extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { getDocuments, user } = this.props
    const customization = user.licenseData.customizationId
    const disabled = customization ? '' : 'disabled'
    return (
      <UIButton
        id="documents"
        icon="icon-content"
        position={`position--absolute right offset-bottom-1 z-index1 ${disabled}`}
        action={() => {
          customization ? getDocuments() : null
        }}
      />
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
    getDocuments: bindActionCreators(docActions.loadData, dispatch),
  }
}

const mapStateToProps = (state) => {
  return {
    user: Auth.selectors.getUserInfo(state),
  }
}

DocumentsButton.propTypes = {
  getDocuments: PropTypes.func,
  user: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DocumentsButton))
